import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Payroll Expense Space Cluster Assignment: The association(s) between payroll expenses and physical space, used for cost allocation.',
    name: 'Payroll Expense Space Cluster Assignments',
    partialId: PartialId.Standard.create('pay_exp_space_cluster'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
